import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import '../App.css';
import '../App.js';
import Privacy from './Privacy';
import Error from './Error';
//import logoImage from "../images/logo.png";
function Terms() {
  return (
    <div className="App">
      <header className="App-header-page">
        <h1>Terms and Conditions</h1>
		
      </header>
      <main className="App-main-page">
	  
        <section style={{ margin: '3%' }}>
	 <div className="content-section terms-container" style={{ padding: '3%' }}>
          <p>Effective Date: 25th January 2025</p>
    
    <p>Welcome to World Radio! These Terms and Conditions ("Terms") govern your use of the World Radio mobile application and the services provided through it (the "Service"). By downloading, installing, or using the app, you agree to comply with these Terms. If you do not agree, please refrain from using the app.</p>

    <h2>1. Acceptance of Terms</h2>
    <p>By using the World Radio app, you agree to these Terms and any updates made to them. We reserve the right to modify these Terms at any time. Updates will be effective immediately upon posting in the app or on our website. You are encouraged to review these Terms periodically to stay informed.</p>

    <h2>2. Description of Service</h2>
    <p>World Radio allows users to access live radio stations from across the globe. The Service includes features like browsing stations by country, genre, or content type, and streaming live broadcasts over an internet connection.</p>

    <h2>3. No Account Required</h2>
    <p>You can use World Radio without creating an account. No personal information is collected from you unless explicitly stated, ensuring a seamless and private experience.</p>

    <h2>4. Intellectual Property</h2>
    <p>All content, trademarks, logos, and other intellectual property associated with World Radio are owned by Curious IT or licensed by third parties. You are prohibited from reproducing, modifying, distributing, or exploiting any content from the app without prior written consent.</p>

    <h2>5. Usage Restrictions</h2>
    <p>By using the app, you agree to:</p>
    <ul>
        <li>Use the app only for lawful purposes.</li>
        <li>Refrain from engaging in activities that violate laws, infringe on intellectual property, or disrupt the Service.</li>
        <li>Avoid reverse engineering, decompiling, or tampering with the app.</li>
    </ul>

    <h2>6. Privacy Policy</h2>
    <p>Your use of World Radio is subject to our Privacy Policy, which outlines how we collect, use, and protect data. By using the app, you agree to the terms of the Privacy Policy.</p>

    <h2>7. Third-Party Content</h2>
    <p>The app may provide access to third-party websites or services, including streaming radio stations. We are not responsible for the content, privacy practices, or functionality of third-party services. Use of such services is at your own risk.</p>

    <h2>8. Personalized Push Notifications</h2>
    <p>To enhance your experience, the app may send personalized push notifications about updates, features, or promotions. You can manage your notification preferences through your device settings.</p>

    <h2>9. Limitation of Liability</h2>
    <p>The World Radio app is provided "as is" and "as available." We do not guarantee uninterrupted or error-free operation of the app. To the maximum extent allowed by law, [Your Company Name] is not liable for any indirect, incidental, or consequential damages resulting from your use of the app.</p>

    <h2>10. Children’s Use</h2>
    <p>The app is intended for users of appropriate age based on local laws.</p>
    <ul>
        <li><strong>Globally:</strong> Users must be 12 or older.</li>
        <li><strong>EEA:</strong> Users must be 16 or older.</li>
        <li><strong>India:</strong> Users must be 18 or older.</li>
    </ul>
    <p>Parents and guardians are encouraged to supervise children’s usage. Refer to the <a href="/privacy">Privacy Policy</a> for additional details on children’s data protection.</p>

    <h2>11. Termination of Service</h2>
    <p>We may terminate or suspend your access to the app at any time for any reason, including violations of these Terms. Upon termination, you must cease all use of the app.</p>

    <h2>12. Governing Law and Jurisdiction</h2>
    <p>These Terms are governed by the laws of India. Any disputes related to these Terms will be subject to the jurisdiction of courts located in India.</p>

    <h2>13. Contact Information</h2>
    <p>For questions or concerns, contact us at:</p>
    <p><strong>World Radio Support Team</strong></p>
    <p><strong>Email:</strong> <a href="mailto:[Insert Contact Email]">curiousitinfo+support@gmail.com</a></p>

    <p>© 2025 Curious IT. All rights reserved.</p>
		  </div>
        </section>
      </main>
      <footer className="App-footer-page">
        <Link to="/">Home</Link> |
        <Link to="/terms">Terms and Conditions</Link> |
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default Terms;
